/* eslint-disable react/jsx-no-target-blank */
import { useFilter } from '../../FilterContext'
import { useParams } from 'react-router-dom'
import clsx from 'clsx'
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import { useIntl } from 'react-intl';

interface DescriptorStatus {
  readonly value: string;
  readonly label: string;
}

export function CdrnDescriptorsFilter() {
  const params = useParams()
  const intl = useIntl()
  const { globalFilter, setGlobalFilter } = useFilter()

  const DescriptorStatus: DescriptorStatus[] = [
    { value: 'ENABLED', label: 'Enabled' },
    { value: 'DELETED', label: 'Deleted' },
    { value: 'FAILED', label: 'Failed' },
  ];

  return (
    <>
      <div className={(clsx(params.id ? 'blur' : ''))}>
        <div className='d-flex'>
          {/* Status */}
          <MultiSelection
            title={intl.formatMessage({ id: 'DESCRIPTORS.STATUS' })}
            globalFilterValue={globalFilter?.['cdrnDescriptorList']?.status?.values}
            options={DescriptorStatus}
            onChange={(e) => {
              setGlobalFilter({ ...globalFilter, cdrnDescriptorList: { ...globalFilter.cdrnDescriptorList, status: { type: "in", values: e } } });
            }} />

          {/* Search */}
          <SearchInputGroup
            inputs={[ // key = filter key
              { key: 'payment_descriptor', title: 'Payment Descriptor' },
            ]}
            section='cdrnDescriptorList' // globalFilter section key
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) => setGlobalFilter({ ...globalFilter, cdrnDescriptorList: { ...globalFilter.cdrnDescriptorList, ...searchValues } })}
            onClear={(searchValues) => setGlobalFilter({ ...globalFilter, cdrnDescriptorList: { ...globalFilter.cdrnDescriptorList, ...searchValues } })}
          />
        </div>
      </div>
    </>
  )
}
